import { render } from "./App.vue?vue&type=template&id=8551e346"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8551e346&lang=css"

import exportComponent from "D:\\work\\jyzs\\jyzs-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__